export enum EFormMode {
  CREATE = 'create',
  UPDATE = 'update',
  FILTER = 'filter',
}
